import React from "react";
import PropTypes from "prop-types";
import getStyled from "../../hooks/getStyled";
import SFTypography from "../typography";
import { SFStack } from "../grid";
import SFButton from "../button";

const { styled } = getStyled();

const StyledBannerWrapper = styled("div", { shouldForwardProp: false })(
  ({ theme, bgColor }) => ({
    padding: theme.spacing(2),
    width: "100%",
    borderRadius: "4px",
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.grey225.main}`,
    marginBottom: theme.spacing(3),
  })
);

// const StyledBannerWrapper = styled("div", { shouldForwardProp: false })(
//   ({ theme, bgColor }) => ({
//     padding: theme.spacing(2),
//     width: "100%",
//     borderRadius: "4px",
//     backgroundColor:
//       bgColor === "primary"
//         ? theme.palette.grey100.main
//         : theme.palette.white.main,
//     border:
//       bgColor === "primary" ? null : `1px solid ${theme.palette.grey225.main}`,
//     marginBottom: theme.spacing(3),
//   })
// );

const BannerIconStyled = styled("div")(({ theme }) => ({
  marginRight: 35,
  overflow: "unset",
  "& svg": {
    width: "50px",
    height: "auto",
  },
}));

const SFHeaderBannerNavigation = ({
  url,
  label,
  icon,
  children,
  bgColorVariant = "primary",
  onClick = null,
  buttonIcon = null,
  buttonVariant = "primary",
  className,
}) => {
  return (
    <StyledBannerWrapper className={className} bgColor={bgColorVariant}>
      <SFStack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <SFStack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          spacing={0}
        >
          <BannerIconStyled>{icon}</BannerIconStyled>
          <SFTypography variant="body1" hasHtml>{children}</SFTypography>
        </SFStack>
        {onClick && (
          <SFButton variant={buttonVariant} onClick={onClick} icon={buttonIcon}>
            {label}
          </SFButton>
        )}
      </SFStack>
    </StyledBannerWrapper>
  );
};

SFHeaderBannerNavigation.propTypes = {
  icon: PropTypes.node,
  children: PropTypes.node,
  bgColorVariant: PropTypes.oneOf(["primary", "secondary"]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
export default SFHeaderBannerNavigation;
